<template>
	<div class="detail-view music">
		<music-page></music-page>
	</div>
</template>

<script>
import MusicPage from "../components/pages/MusicPage";
import { inject } from "vue";

export default {
  name: "Music",
  components: {
		MusicPage,
	},
  setup() {
    const store = inject("store");
    return {
			actions: store.actions
    };
  },

}
</script>

<style lang="scss">
// .detail-view {
// 	&.music {
// 		.product-detail {
// 			top: -10vh;
//       left: 0;
//       right:0;
//       margin: 0 auto;
//       max-width: 100%;
//       width: 100%;
// 		}
//     @media (max-width: 414px) {
//       .product-detail {
//         top: 0;
//       }
//     }
// 	}
// }
</style>
